/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useState } from 'react';

import { setAuthToken, getAuthToken } from 'service/utilities';

const AuthContext = React.createContext();
const AuthUpdateContext = React.createContext();

// Hook for child components to get the auth object (read-only)
export function useAuth() {
  return useContext(AuthContext);
}

// Hook for child components to update the auth object ...
export function useAuthUpdate() {
  return useContext(AuthUpdateContext);
}

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that contains the auth object(by inovoking useAuth()) and can set auth object( invoking useAuthUpdate())
// eslint-disable-next-line react/prop-types
export function AuthProvider({ children, initialStatus = false }) {
  const [isUserLoggedIn, setUserLoggedIn] = useState(initialStatus);
  const [userData, setUserData] = useState({});

  // when useAuthUpdate() function is invoked this fuction updates the auth state in the Main Auth Context
  function updateUserState(status) {
    setUserLoggedIn(status);
  }

  function updateUserData(data) {
    setUserData(data);
  }

  async function updateUserToken(token, data) {
    localStorage.setItem('token', token);
    await setUserLoggedIn(true);
    setAuthToken(token);
    if (data) updateUserData(data);
  }

  async function refreshUserData() {
    // call get user api
  }

  async function checkToken() {
    const authToken = getAuthToken();

    if (authToken && !isUserLoggedIn) {
      updateUserState(true);

      refreshUserData();
    }
  }

  // Check if the auth token is present/not and check the Main AuthContext status, update the Main AuthContext according to those things.
  useEffect(() => {
    checkToken();
  }, []);

  // CHECK IF THE TOKEN IS PRESENT ELSE LOG HIM OUT IF HE'S LOGGED IN
  useEffect(() => {
    if (!getAuthToken() && isUserLoggedIn) {
      updateUserState(false);
      // logout();
    }
  });

  return (
    <AuthContext.Provider value={{ isUserLoggedIn, userData }}>
      <AuthUpdateContext.Provider
        value={{
          updateUserState,
          updateUserToken,
          updateUserData,
          refreshUserData
        }}
      >
        {children}
      </AuthUpdateContext.Provider>
    </AuthContext.Provider>
  );
}
